module.exports = __webpack_public_path__ + "img/dotmenu.832b1a46.svg";